export default __webpack_public_path__ + "static/media/qanda-btn.4314e997.svg";